export default "__VITE_ASSET__DTa5PdXO__"